import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-heading font-bold text-primary-500">
              皮皮漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/kr"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-4">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 w-48 transition-all duration-200"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`text-lg text-foreground-700 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link
              to="/"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2"
            >
              首页
            </Link>
            <Link
              to="/category/kr"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2"
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2"
            >
              关于我们
            </Link>
            <div className="relative pt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300"
              />
              <i className="ri-search-line absolute left-3 top-[55%] -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}